import React from "react";
import "./New_Rank.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

const New_Rank = () => {
  return (
    <section className="newrank">
      <div className="container">
        <div className="widget_title text-center">
          <h3 className="rank_head">
            Ranked and Accredited:
            <span> D Y Patil Legacy You Can Trust</span>
          </h3>
        </div>

        <div className="row align-items-center">
          <div className="col-lg-12">
            <Swiper
              modules={[Autoplay, Pagination]}
              spaceBetween={20}
              slidesPerView={2}
              loop={true}
              autoplay={{
                delay: 3500,
                disableOnInteraction: true,
              }}
              pagination={{
                clickable: true,
                dynamicBullets: 1,
              }}
              breakpoints={{
                0: {
                  slidesPerView: 2.2,
                  spaceBetween: 10,
                },
                450: {
                  slidesPerView: 2.8,
                  spaceBetween: 10,
                },
                576: { slidesPerView: 3 },
                769: { slidesPerView: 4 },
                1200: { slidesPerView: 5 },
              }}
              className="text-center my-md-4 my-3"
            >
              <SwiperSlide>
                <div className="rank_content">
                  <div className="content_Img">
                    <img
                      src="/assets/images/home/rank/nirf.png"
                      alt="NIRF Ranking"
                    />
                    <h2 className="rank_subhead">Top 50</h2>
                    <p className="sub_head">
                      Ranked in <br /> Universities
                    </p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="rank_content">
                  <div className="content_Img">
                    <img
                      src="/assets/images/home/rank/NAAC.png"
                      alt="NAAC A++ Grade"
                    />
                    <h2 className="rank_subhead">A++ Grade</h2>
                    <p className="sub_head">Accreditation</p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="rank_content">
                  <div className="content_Img dflex">
                    <img
                      src="/assets/images/home/rank/r3.png"
                      alt="THE Impact Rankings"
                    />
                    <div className="secImg">
                      <img
                        src="/assets/images/home/rank/r3a.png"
                        alt="SDG Ranking"
                      />
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="rank_content">
                  <div className="content_Img">
                    <img
                      src="/assets/images/home/rank/r4.png"
                      alt="QS I-GAUGE Diamond"
                    />
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="rank_content">
                  <div className="content_Img dflex">
                    <img
                      src="/assets/images/home/rank/r5.png"
                      alt="Competition Success Review Rank 1"
                    />
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default New_Rank;
